import { useTranslations } from '@lang';
import { some } from '@utils/some';

import { ExtrasSection } from '../ExtrasStep/ExtrasSection';
import { useStepFooter } from '../hooks/useStepFooter';
import { GuestDetailsWrapper, TitleWrapper } from './RoomExtrasStep.styles';
import { PageTitle } from '../FormSteps.styles';
import { usePackageConfiguration } from '../../contexts';

export const RoomExtrasStep = () => {
  const { t } = useTranslations();

  const { availableExtras = [] } = usePackageConfiguration();

  const footer = useStepFooter();

  return (
    <GuestDetailsWrapper>
      {some(availableExtras) && (
        <>
          <TitleWrapper>
            <PageTitle>{t('room.extrasStepTitle')}</PageTitle>
          </TitleWrapper>

          <ExtrasSection />
        </>
      )}
      {footer}
    </GuestDetailsWrapper>
  );
};
